import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { PrimaryData } from 'app-models';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';


@Component({
  selector: 'app-uscis-content',
  templateUrl: './uscis-content.component.html',
  styleUrls: ['./uscis-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UscisContentComponent implements OnInit {

  primaryData: PrimaryData;

  constructor(
    public dynamicDialogRef: DynamicDialogRef,
    public dynamicDialogConfig: DynamicDialogConfig,
  ) {  }

  ngOnInit() {
    this.primaryData = this.dynamicDialogConfig.data;
    // console.log("UscisContentComponent  L1:: ",this.dynamicDialogConfig.data);
  }

  handleDialogClose() {
    this.dynamicDialogRef.close();
  }
}
